import styled from 'styled-components';
import img_intro from '../../assets/RJ/RJ_intro.jpg';
import img_raquelyjuan from '../../assets/RaquelyJuan.png';
import img_footer from '../../assets/RJ/img_footer.jpg';
import { getFontSize } from '../../utils/getFont';

export const CommonContainer = styled.div`
  text-align: center;
  padding: 1rem 0 0;
  color: var(--text);
`;

export const BackgroundImage = styled.div`
  z-index: 0;
  background: url(${img_intro}) no-repeat center center;
  background-size: cover;
  background-position: bottom;
  position: relative;

  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom}px;`}

  width: 100%;
  height: 100%;
  min-height: 675px;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 470px) {
    min-height: 500px;
    background-size: auto 110%;
    background-repeat: no-repeat;
    background-position: bottom;
  }

  // make bottom of the image transparent transition
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 170px;
    background: linear-gradient(to bottom, transparent, var(--background));
    z-index: 1;
  }
`;

const ImageRyJ = styled.img`
  max-width: 300px;
  height: auto;
  margin-top: 2rem;

  margin-left: auto;
  margin-right: auto;

  @media (max-width: 470px) {
    max-width: 200px;
    margin-top: 2rem;
  }

  // withShadow prop to add a background shadow effect to make the image pop
  ${({ withShadow }) =>
    withShadow &&
    `
    filter: drop-shadow(2px 4px 20px rgba(255, 249, 224, 1));
  `}
`;

export const RaquelyJuan = (props) => <ImageRyJ src={img_raquelyjuan} alt="Raquel y Juan" {...props} />;

const ImageFooter = styled.div`
  z-index: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 30px;

  h2 {
    z-index: 2;
    font-family: var(--text-cursive2);
    ${getFontSize(10)}

    margin-bottom: 30px;
  }

  // @media (max-width: 470px) {
  //   background: url(${img_footer}) no-repeat center center;
  //   background-size: cover;
  //   background-position: top;
  //   position: relative;

  //   height: 500px;

  //   h2 {
  //     margin-bottom: 0;
  //   }

  //   &::before {
  //     content: '';
  //     position: absolute;
  //     top: -1px;
  //     left: 0;
  //     width: 100%;
  //     height: 170px;
  //     background: linear-gradient(to top, transparent, var(--background));
  //     z-index: 1;
  //   }
  // }
`;

export const FooterImg = (props) => (
  <ImageFooter {...props}>
    <h2>¡Te esperamos!</h2>
  </ImageFooter>
);
